webpackJsonp([1],{

/***/ "0M5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DE+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IEnn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4a906d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("bp21")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e24576","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WAiT")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-16e24576"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33914d2d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("IEnn")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-33914d2d"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ee6250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("uL/m")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3871240a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("0M5Z")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f9ed8b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("xda7")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee1b5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("DE+O")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482838ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("opfQ")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b75a8e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("ckHF")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27efe336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("u/WO")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-27efe336"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b990a520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("biBg")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12525ca8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("NXlJ")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35db5a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dUvF")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Get Ready Pack: Milano Cortina 2026",
  "shortTitle": "",
  "description": "",
  "width": 620,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://getreadypack.olympics.com/milanocortina2026/en/"
  }, {
    code: "FR",
    text: "Français",
    href: "https://getreadypack.olympics.com/milanocortina2026/fr/"
  }, {
    code: "ES",
    text: "Español",
    href: "https://getreadypack.olympics.com/milanocortina2026/es/"
  }, {
    code: "IT",
    text: "Italiano",
    href: "https://getreadypack.olympics.com/milanocortina2026/it/"
  }, {
    code: "CN",
    text: "Chinese",
    href: "https://getreadypack.olympics.com/milanocortina2026/cn/"
  }, {
    code: "RU",
    text: "Russian",
    href: "https://getreadypack.olympics.com/milanocortina2026/ru/"
  }],
  "basePath": "/milanocortina2026/en",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "https://getreadypack.olympics.com/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/milanocortina2026/en/static/_content/Athlete365_GetReadyPack_MilanoCortina_v2.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 1-logo\" style=\"top:17px;left:-53px;\" src=\"/milanocortina2026/en/static/_content/1-logo-1.png\"/>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:-26px;left:-203px;\" src=\"/milanocortina2026/en/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScaleC 1-sub\" style=\"top:461px;left:-134px;\" src=\"/milanocortina2026/en/static/_content/1-sub-1.png\"/>\n      <img class=\"abs halfScaleC\" style=\"top:46px;left:233px;\" src=\"/milanocortina2026/en/static/_content/1-image-1.png\"/>\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <a href=\"https://www.olympics.com/athlete365\" target=\"_blank\" class=\"pointer\">\n        <img class=\"abs halfScaleC 1-logo\" style=\"top:17px;left:-53px;\" src=\"/milanocortina2026/en/static/_content/1-logo-1.png\"/>\n      </a>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:-26px;left:-203px;\" src=\"/milanocortina2026/en/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScaleC 1-sub\" style=\"top:461px;left:-134px;\" src=\"/milanocortina2026/en/static/_content/1-sub-1.png\"/>\n      <img class=\"abs halfScaleC\" style=\"top:46px;left:233px;\" src=\"/milanocortina2026/en/static/_content/1-image-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 3-btn pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:695px;left:444px;\" src=\"/milanocortina2026/en/static/_content/1-arrow-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"1-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"1-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "get ready PACK MILANO CORTINA 2026"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 2-title\" style=\"top:94px;left:41px;\" src=\"/milanocortina2026/en/static/_content/2-title-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:188px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:201px; left:68px; width:208px; height:12px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(5);\" style=\"top:232px; left:62px; width:128px; height:18px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:250px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(7);\" style=\"top:263px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:277px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" style=\"top:290px; left:68px; width:208px; height:12px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(10);\" style=\"top:322px; left:63px; width:150px; height:18px;\"></div>\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(11);\" style=\"top:340px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:353px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:367px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:380px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:394px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:407px; left:68px; width:208px; height:12px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(17);\" style=\"top:439px; left:62px; width:108px; height:18px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:458px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(19);\" style=\"top:471px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:485px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:498px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:513px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(24);\" style=\"top:526px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(25);\" style=\"top:540px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:554px; left:68px; width:208px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(27);\" style=\"top:568px; left:68px; width:208px; height:12px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(28);\" style=\"top:186px; left:332px; width:210px; height:18px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:205px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:219px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(31);\" style=\"top:233px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(32);\" style=\"top:247px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:261px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:274px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(35);\" style=\"top:288px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(36);\" style=\"top:302px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(37);\" style=\"top:316px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:330px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(39);\" style=\"top:342px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:356px; left:337px; width:228px; height:12px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(41);\" style=\"top:385px; left:332px; width:86px; height:18px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(42);\" style=\"top:405px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(43);\" style=\"top:418px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(44);\" style=\"top:432px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(45);\" style=\"top:446px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(46);\" style=\"top:459px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(47);\" style=\"top:473px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:487px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(49);\" style=\"top:502px; left:337px; width:228px; height:12px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(50);\" style=\"top:514px; left:337px; width:228px; height:12px;\"></div>\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Contents  Contents  2  contents 3 Join the community 4 Welcome to Milano Cortina 2026  Getting to the games 6 7 8 9  Arrivals Accreditation Transport Olympic Villages map  Welcome to your Village 11 Milan 12 Cortina 13 Predazzo 14 Livigno 15 Bormio 16 Anterselva  Life in the Village  18 Olympic Village services 19 Athlete365 House 20 IOC Athletes' Commission election 22 Athlete365 x Powerade Mind Zone 23 Believe in Sport ambassadors 24 Pamper yourself with P&G 25 Paying with Visa 26 Your Golden Moment 27 Eating and drinking  Maximising your Games experience 29 Airbnb500 30 Olympic Edition Samsung phone 31 Athlete Moment 32 Capture your Olympic experience 33 Social media verification 34 Online abuse protection 35 Athlete365 app 36 Athlete365 Learning 37 PinQuest 38 How to access tickets 39 Opening Ceremony 40 Get Set – Train Smarter  Need to know  42 Getting to your competition venue 43 How to seek help 44 Social media guidelines 45 Athlete Expression 46 Commercial opportunities 47 Prevention of competition manipulation 48 Anti-doping 49 Sustainability 50 Departures"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 3-title\" style=\"top:70px;left:41px;\" src=\"/milanocortina2026/en/static/_content/3-title-1.png\"/>\n      <img class=\"abs halfScale 3-sub\" style=\"top:159px;left:40px;\" src=\"/milanocortina2026/en/static/_content/3-sub-1.png\"/>\n\n      <img class=\"abs halfScale 3-box\" style=\"top:513px;left:-37px;\" src=\"/milanocortina2026/en/static/_content/3-box-1.png\"/>\n      <img class=\"abs halfScale 3-box\" style=\"top:605px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/3-box-2.png\"/>\n      <img class=\"abs halfScale 3-box\" style=\"top:698px;left:-31px;\" src=\"/milanocortina2026/en/static/_content/3-box-3.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/auth/sign-in\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 3-btn\" style=\"top:770px;left:-35px;\" src=\"/milanocortina2026/en/static/_content/3-btn-1.png\"/>\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(cOf(\"3-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"3-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"3-box\"), 0.7, {opacity:0, x: -513}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.4)\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Join the community  Join the community We’re on a mission to make athletes’ lives better.  Athlete365 is the global community for Olympians, Paralympians, elite-level athletes and their entourage members. We have more than 200,000 members from around the world, and we’d love you to join us. Here’s why you should sign up today.  Access our exclusive offers  Including the Airbnb500 Travel Grant.  Level up with Athlete365 Learning and Career+ Empower yourself on and off the field of play.  Personalise your Athlete365 experience  Get the content that matters most to you.  SIGN UP NOW  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 4-title\" style=\"top:66px;left:20px;\" src=\"/milanocortina2026/en/static/_content/4-title-1.png\" />\n      <img class=\"abs halfScale 4-title\" style=\"top:139px;left:23px;\" src=\"/milanocortina2026/en/static/_content/4-title-2.png\" />\n      <img class=\"abs halfScale 4-sub\" style=\"top:230px;left:21px;\" src=\"/milanocortina2026/en/static/_content/4-sub-1.png\" />\n\n      <img class=\"abs halfScaleC 4-icon-lg\" style=\"top:265px;left:-18px;\" src=\"/milanocortina2026/en/static/_content/4-icon-lg-1.png\" />\n      <img class=\"abs halfScaleC 4-icon-lg\" style=\"top:265px;left:295px;\" src=\"/milanocortina2026/en/static/_content/4-icon-lg-2.png\" />\n\n      <h1 id=\"4-no\" class=\"abs olympicHeadlineReg 4-no\" style=\"top:290px;left:109px; font-size: 3.3em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;\"  data-number='{\"to\": 13}' ></h1>\n      <img class=\"abs halfScaleC 4-text\" style=\"top:327px;left:45px;\" src=\"/milanocortina2026/en/static/_content/4-text-1.png\" />\n\n      <h1 id=\"4-no\" class=\"abs olympicHeadlineReg 4-no\" style=\"top:290px;left:422px; font-size: 3.3em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;\"  data-number='{\"to\": 16}' ></h1>\n      <img class=\"abs halfScaleC 4-text\" style=\"top:326px;left:367px;\" src=\"/milanocortina2026/en/static/_content/4-text-2.png\" />\n\n      <img class=\"abs halfScale 4-line-lg\" style=\"top:402px;left:17px;\" src=\"/milanocortina2026/en/static/_content/4-line-lg.png\" />\n\n      <h1 id=\"4-no\" class=\"abs olympicHeadlineReg 4-no\" style=\"top:412px;left:20px; font-size: 1.4em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;\"  data-number='{\"to\": 116}' ></h1>\n      <img class=\"abs halfScale 4-text-left\" style=\"top:421px;left:23px;\" src=\"/milanocortina2026/en/static/_content/4-text-3.png\" />\n\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:439px;left:6px;\" src=\"/milanocortina2026/en/static/_content/4-icon-1.png\" />\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:485px;left:6px;\" src=\"/milanocortina2026/en/static/_content/4-icon-2.png\" />\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:521px;left:6px;\" src=\"/milanocortina2026/en/static/_content/4-icon-3.png\" />\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:439px;left:160px;\" src=\"/milanocortina2026/en/static/_content/4-icon-4.png\" />\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:475px;left:160px;\" src=\"/milanocortina2026/en/static/_content/4-icon-5.png\" />\n      <img class=\"abs halfScaleC 4-icon\" style=\"top:511px;left:160px;\" src=\"/milanocortina2026/en/static/_content/4-icon-6.png\" />\n\n      <img class=\"abs halfScale 4-text-left\" style=\"top:455px;left:49px;\" src=\"/milanocortina2026/en/static/_content/4-text-4.png\" />\n      <img class=\"abs halfScale 4-text-left\" style=\"top:502px;left:49px;\" src=\"/milanocortina2026/en/static/_content/4-text-5.png\" />\n      <img class=\"abs halfScale 4-text-left\" style=\"top:538px;left:49px;\" src=\"/milanocortina2026/en/static/_content/4-text-6.png\" />\n      <img class=\"abs halfScale 4-text-left\" style=\"top:456px;left:204px;\" src=\"/milanocortina2026/en/static/_content/4-text-7.png\" />\n      <img class=\"abs halfScale 4-text-left\" style=\"top:492px;left:205px;\" src=\"/milanocortina2026/en/static/_content/4-text-8.png\" />\n      <img class=\"abs halfScale 4-text-left\" style=\"top:528px;left:205px;\" src=\"/milanocortina2026/en/static/_content/4-text-9.png\" />\n\n      <img class=\"abs halfScale 4-line-sm\" style=\"top:417px;left:324px;\" src=\"/milanocortina2026/en/static/_content/4-line-sm.png\" />\n\n      <img class=\"abs halfScale 4-bar-1\" style=\"top:466px;left:351px;\" src=\"/milanocortina2026/en/static/_content/4-bar-1.png\" />\n      <img class=\"abs halfScale 4-bar-2\" style=\"top:466px;left:468px;\" src=\"/milanocortina2026/en/static/_content/4-bar-2.png\" />\n      <img class=\"abs halfScaleC 4-line-dot\" style=\"top:385px;left:293px;\" src=\"/milanocortina2026/en/static/_content/4-line-dot.png\" />\n      <h1 id=\"4-no\" class=\"abs olympicHeadlineReg 4-no\" style=\"top:412px;left:365px; font-size: 1.4em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;\"  data-number='{\"to\": 47, \"append\": \"%\"}' ></h1>\n      <img class=\"abs halfScale 4-text-right\" style=\"top:437px;left:366px;\" src=\"/milanocortina2026/en/static/_content/4-text-10.png\" />\n      <img class=\"abs halfScale 4-text-right\" style=\"top:510px;left:352px;\" src=\"/milanocortina2026/en/static/_content/4-text-11.png\" />\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"4-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .staggerFromTo(cOf(\"4-icon-lg\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.4, 1.6)\n          .fromTo(cOf(\"4-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"4-no\")[0])}}, 1.8)\n          .staggerFromTo(cOf(\"4-text\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.9)\n          .fromTo(cOf(\"4-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"4-no\")[1])}}, 1.9)\n          .fromTo(cOf(\"4-line-lg\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"4-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"4-no\")[2])}}, 2.1)\n          .staggerFromTo(cOf(\"4-text-left\"), 0.3, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2.2)\n          .staggerFromTo(cOf(\"4-icon\"), 0.3, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.3)\n          .fromTo(cOf(\"4-line-sm\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)\n          .fromTo(cOf(\"4-bar-1\"), 0.7, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"4-bar-2\"), 0.7, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"4-line-dot\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.45)\n          .fromTo(cOf(\"4-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"4-no\")[3])}}, 2.5)\n          .staggerFromTo(cOf(\"4-text-right\"), 0.3, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.6)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"4-no\");\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Welcome to Milano Cortina 2026  Contents  4  Welcome to Milano Cortina 2026 Blending decades of winter sports expertise, legendary venues and a passionate local fan base, Milano Cortina 2026 will be truly unique.  13  16  competition venues  disciplines  With breathtaking backdrops across northern Italy  Featuring an Olympic debut for ski mountaineering  47%  116 medal events  Including new medal events in:  Alpine skiing  men’s and women’s team combined  Freestyle skiing  men’s and women’s dual moguls  Luge  women’s doubles  female athletes Skeleton  mixed team  Ski jumping  women’s large hill  Ski mountaineering  men’s and women’s sprint, mixed relay  Making this the most gender-balanced Olympic Winter Games in history"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 5-title\" style=\"top:106px;left:200px;\" src=\"/milanocortina2026/en/static/_content/5-title-1.png\"/>\n      <img class=\"abs halfScale 5-title\" style=\"top:177px;left:200px;\" src=\"/milanocortina2026/en/static/_content/5-title-2.png\"/>\n      <img class=\"abs halfScale 5-title\" style=\"top:580px;left:90px;\" src=\"/milanocortina2026/en/static/_content/5-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:633px; left:238px; width:156px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(7);\" style=\"top:671px; left:238px; width:156px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:709px; left:238px; width:156px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" style=\"top:747px; left:238px; width:156px; height:22px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim.staggerFromTo(cOf(\"5-title\"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Getting to the Games  Contents  GETTING TO the GAMES  Your journey at Milano Cortina 2026 starts here. 6 Arrivals 7 Accreditation 8 Transport 9 Olympic Villages map  Getting to the games  5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 6-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/6-title-1.png\"/>\n      <img class=\"abs halfScale 6-sub\" style=\"top:149px;left:20px;\" src=\"/milanocortina2026/en/static/_content/6-sub-1.png\"/>\n\n      <a href=\"https://athlete365.org/arrivals-mico-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 6-btn\" style=\"top:746px;left:274px;\" src=\"/milanocortina2026/en/static/_content/6-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"6-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Arrivals  6  Arrivals What to expect when you arrive in Italy. Due to the widespread nature of Milano Cortina 2026, the arrivals system is split into two zones.  West Zone Villages: Milan, Livigno and Bormio Main point of entry: Milano Malpensa Airport Other entry points:  • Milano Centrale train station and Milano Linate Airport (for Milan) • Tirano train station (for Livigno and Bormio)  Journey times from Milano Malpensa Airport: Milan Village: 1 h 30 mins Bormio Village: 4 h 30 mins Livigno Village: 6 h 45 mins  East Zone Villages: Cortina, Predazzo, Anterselva Main point of entry: Venezia Marco Polo Airport Other entry points:  • Venezia Mestre train station (for Cortina or Anterselva) • Trento train station (for Predazzo) • Valdaora train station (for Anterselva)  Journey times from Venezia Marco Polo Airport: Cortina Village: 3 h 15 mins Predazzo Village: 3 h 50 mins Anterselva Village: 4 h 35 mins  Getting to the games  FIND OUT MORE If you have any questions about your arrival procedure, speak to your NOC, e.g. your Chef de Mission."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 7-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/7-title-1.png\"/>\n      <img class=\"abs halfScale 7-sub\" style=\"top:149px;left:20px;\" src=\"/milanocortina2026/en/static/_content/7-sub-1.png\"/>\n\n      <img class=\"abs halfScale 7-box\" style=\"top:462px;left:18px;\" src=\"/milanocortina2026/en/static/_content/7-box-1.png\"/>\n      <img class=\"abs halfScale 7-box\" style=\"top:462px;left:211px;\" src=\"/milanocortina2026/en/static/_content/7-box-2.png\"/>\n      <img class=\"abs halfScale 7-box\" style=\"top:462px;left:406px;\" src=\"/milanocortina2026/en/static/_content/7-box-3.png\"/>\n\n      <img class=\"abs halfScale 7-box-4\" style=\"top:741px;left:261px;\" src=\"/milanocortina2026/en/static/_content/7-box-4.png\"/>\n\n      <img class=\"abs halfScale 7-box-5\" style=\"top:833px;left:-35px;\" src=\"/milanocortina2026/en/static/_content/7-bottom-bar.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"7-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"7-box\"), 0.7, {opacity:0, y: 400}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.4)\n          .fromTo(cOf(\"7-box-4\"), 0.7, {opacity:0, x: 400}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Accreditation  Contents  7  Accreditation How to validate your accreditation and keep it safe.  1  Before travelling to the Games, you will be issued with a Pre-Valid Card (PVC). If you require a visa, this will be printed on your PVC, which must be presented at immigration with a valid travel document.  2  Your PVC must then be validated when you arrive at the Games. You will then be issued with an Olympic Identity and Accreditation Card (OIAC).  3  Your OIAC is your official accreditation, granting you access to the venues and services you need. You must carry it with you at all times, apart from training or competition.  TIP: Hang your accreditation on the inside door handle of your room before you go to bed. Then, when you leave your room, you’ll be reminded to put it on. For more information, please contact your NOC.  Getting to the games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 8-title\" style=\"top:85px;left:80px;\" src=\"/milanocortina2026/en/static/_content/8-title-1.png\"/>\n      <img class=\"abs halfScale 8-title\" style=\"top:148px;left:193px;\" src=\"/milanocortina2026/en/static/_content/8-sub-1.png\"/>\n      <img class=\"abs halfScale 8-title\" style=\"top:185px;left:198px;\" src=\"/milanocortina2026/en/static/_content/8-text-1.png\"/>\n      <img class=\"abs halfScale 8-title\" style=\"top:220px;left:109px;\" src=\"/milanocortina2026/en/static/_content/8-line-1.png\"/>\n\n      <img class=\"abs halfScaleC 8-box\" style=\"top:138px;left:-70px;\" src=\"/milanocortina2026/en/static/_content/8-box-1.png\" />\n      <img class=\"abs halfScaleC 8-box\" style=\"top:138px;left:130px;\" src=\"/milanocortina2026/en/static/_content/8-box-2.png\" />\n      <img class=\"abs halfScaleC 8-box\" style=\"top:138px;left:330px;\" src=\"/milanocortina2026/en/static/_content/8-box-3.png\" />\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"8-box\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Transport  Contents  8  Your transport options How to get around at the Games. You will have three main transport options available to you at Milano Cortina 2026.  Transport for Athletes (TA)  Public Transport (TP)  Transport Connect (TC)  Point-to-point service from your Village to your training/competition venues  Free access to public transport throughout the Games period  For athletes and accredited entourage members with TA entitlement – priority given to competing athletes  For athletes and eligible accredited entourage members  Extra shuttle service connecting each Village with competition venues, long-term parking areas and hotels  The easiest way to find your way around is the official Milano Cortina 2026 transport app, which will be available closer to the Games.  Getting to the games  For athletes and eligible accredited entourage members"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 9-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/9-title-1.png\"/>\n      <img class=\"abs halfScale 9-sub\" style=\"top:137px;left:21px;\" src=\"/milanocortina2026/en/static/_content/9-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 9-village\" style=\"top:157px;left:208px;\" src=\"/milanocortina2026/en/static/_content/9-village-1.png\" />\n      <img class=\"abs halfScaleC 9-village\" style=\"top:113px;left:353px;\" src=\"/milanocortina2026/en/static/_content/9-village-2.png\" />\n      <img class=\"abs halfScaleC 9-village\" style=\"top:243px;left:370px;\" src=\"/milanocortina2026/en/static/_content/9-village-3.png\" />\n      <img class=\"abs halfScaleC 9-village\" style=\"top:258px;left:247px;\" src=\"/milanocortina2026/en/static/_content/9-village-4.png\" />\n      <img class=\"abs halfScaleC 9-village\" style=\"top:241px;left:230px;\" src=\"/milanocortina2026/en/static/_content/9-village-5.png\" />\n      <img class=\"abs halfScaleC 9-village\" style=\"top:366px;left:124px;\" src=\"/milanocortina2026/en/static/_content/9-village-6.png\" />\n\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(14)\" style=\"top:318px;left:265px;width:84px;height:32px;\"></div>\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(16)\" style=\"top:278px;left:406px;width:104px;height:32px;\"></div>\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(12)\" style=\"top:391px;left:423px;width:84px;height:32px;\"></div>\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(15)\" style=\"top:393px;left:288px;width:79px;height:32px;\"></div>\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(13)\" style=\"top:430px;left:328px;width:97px;height:32px;\"></div>\n      <div class=\"abs addContentLink pointer\" onclick=\"Publish.goToPage(11)\" style=\"top:494px;left:175px;width:84px;height:32px;\"></div>\n      \n\n    ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(cOf(\"9-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"9-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"9-village\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)\n\n          setTimeout(function(){\n            addContentLinks();\n          },3000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();        \n          pg9Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Villages map  9  Olympic Villages map Click on your Village to find out more.  Anterselva Livigno  Bormio Predazzo Milano  Getting to the games  Cortina"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 10-title\" style=\"top:109px;left:181px;\" src=\"/milanocortina2026/en/static/_content/10-title-1.png\"/>\n      <img class=\"abs halfScale 10-title\" style=\"top:178px;left:172px;\" src=\"/milanocortina2026/en/static/_content/10-title-2.png\"/>\n      <img class=\"abs halfScale 10-title\" style=\"top:579px;left:181px;\" src=\"/milanocortina2026/en/static/_content/10-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(11);\" style=\"top:633px; left:188px; width:106px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:671px; left:188px; width:106px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:709px; left:188px; width:106px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:633px; left:318px; width:106px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:671px; left:318px; width:106px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:709px; left:318px; width:106px; height:22px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.staggerFromTo(cOf(\"10-title\"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Welcome to your Village  10  WELCOME TO YOUR VILLAGE  Get to know your new home.  Welcome to your village  11 Milano  14 Livigno  12 Cortina  15 Bormio  13 Predazzo  16 Anterselva"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 11-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/11-title-1.png\"/>\n\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 11-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:454px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"11-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Milan  Contents  11  Milan GROUND FLOOR 10 8  11 9  RAMP TO BASEMENT  12  P  VIA GIUS  5  7  4  1  TC  EPPE RI  2  700 m  PAMONT  3 RIVE E-ART DRIVPO IN  I  6  FLOORS 1-7  RIVE E-ART DRIVPO IN  NNI IOVA VIA G INI Z LOREN  R  B  R  C  R  R  D  R  E  R  F  LI  VIA PRIVATA ERCOLE MAREL  A  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  Unavailable area  0  Entrance/Exit  Metro Station  Transport Mall  Train Station  Pedestrian Screening Area  Polyclinic  Security Perimeter  Internal Perimeter  Lobby Entry to Residental Units  Access Control Point Vehicle Screening Area  Main Dining Hall Main Entry Address (individual deliveries)  Materials Transfer Area  Arrivals and Departures Service  TC Transport Connect  Welcome to your village  1  2  Main Entry Accreditation Centre and Guest Pass Centre  3  Luggage Tent  4  Village Plaza  5  Recreational Areas  6  Athlete365 House  7  Resident Centre  8  Fitness Centre  9  Prayer Room  10  Doping Control Station  11  Mind Zone  12  Uniform Distribution Centre  20m  FLOORS 1-7  R  Residential Units  • Athlete headshots (Building A) • Words of Olympians (Building A) FLOOR -1 Resident Laundries (all buildings)  40m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 12-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/12-title-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 12-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:427px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"12-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Cortina  Contents  12  Cortina 0  25m  P  50m  DRIVE-ARRIVE POINT  STRADA STATALE 51 DI ALEMAGNA  TC  P  CLUSTER PARKING  CORTINA D’AMPEZZO 5 KM  BUILDING 1  3 12  11  10  9  8  7  6  2  1  5  4 BUILDING 2  BUILDING 3  BUILDING 4  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  P  Unavailable area  Transport Mall  NOC Dedicated Parking  Wax Cabins  1 - 12  Residential Blocks  Entrance/Exit  Security Perimeter  Pedestrian Screening Area  Internal Perimeter  Vehicle Screening Area  Entry to Residental Units  BUILDING 1 • Polyclinic • Resident Laundries • Resident Centre • Recreational Areas • Doping Control Stations  • Main Dining Hall • Athlete365 House  First Floor • Prayer Room • Athlete headshots • Words of Olympians  • Team Processing Centre - Main Entry - Accreditation Centre - Guest Pass Centre - Village Plaza  BUILDING 2 • Fitness Centre • Mind Zone Materials Transfer Area  Access Control Point  Arrivals and Departures Service  (individual deliveries)  TC Transport Connect Welcome to your village  Main Entry Address  BUILDING 3  BUILDING 4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 13-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/13-title-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 13-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:460px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(cOf(\"13-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"13-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Predazzo  Contents  13  Predazzo TC  FLOOR +1  R  R  R  9  8  VIA AI CANZOCOI  40m  DRIVE-ARRIVE POINT  DINING HALL  TC  P BUILDING LATEMAR  BUILDING MUSTO  6  AIN  OM M  M FR  Y  ENTR  ITES  P  350  VIA MARCONI  1 2  VIA S. NICOLÒ  GROUND FLOOR  20m  R  R CORSO DE GASPERI  FLOOR +3  0  DA DO  4  STRA  5  R  LOM  NOC NPC  7  3 BUILDING NICOLAUCICH  BUILDING MACCHI BUILDING MONTE CIMONE  BUILDING OLIMPICO  VIA COL. BARBIERI  EXPLORE LIFE IN THE VILLAGE  Dedicated P NOC Parking  Security Perimeter  1  Accreditation centre  Internal Perimeter  2  Guest Pass Centre  3  Main Entry  R  Residential Units  4  Athlete365 House  8  Prayer Room  5  Recreational Areas  9  Mind Zone  Materials Transfer Area  6  Doping Control Station  • Athlete headshots • Words of Olympians  Arrivals and Departures Service  7  Resident Centre  Athletes and Team Officials  Unavailable area Entrance/Exit Transport Mall Main Dining Hall  Entry to Residental Units  Polyclinic  Access Control Point  Resident laundries  Main Entry Address  Pedestrian Screening Area  Vehicle Screening Area  TC Transport Connect  Welcome to your village  FLOOR -1 (Building Musto) Fitness Centre  FLOORS 1-3  (individual deliveries)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 14-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/14-title-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 14-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:425px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"14-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Livigno  CHARME HOTEL ALEXANDER  VI A  FR  EI TA  Livigno  14  VIA  GE RU  S  ALPEN RESORT BIVIO HOTEL  WORKFORCE CENTRE  TC  P  DR IV E PO -A IN RR T IV  E  ACCREDITATION CENTRE & GUEST PASS CENTRE  INTERMONTI HOTEL  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  0  P NOC Dedicated Parking  Unavailable area  Entry to Residental Units  Transport Mall  Access Control Point  Alpen Resort Bivio Hotel  Intermonti Hotel  Main Entry (PSA) Accreditation Centre and Guest Pass Centre Village Plaza Main Dining Hall  Entrance/Exit  Pedestrian Screening Area  Main Entry Address  (individual deliveries)  Residential Units Resident Centre Fitness Centre Recreational Areas  Vehicle Screening Area  Resident Laundries  TBD  Medical Facility Materials Transfer Area  Prayer Room Transport Mall  Arrivals and Departures Service  Athlete365 House Mind Zone Doping Control Station  TC Transport Connect  Welcome to your village  TBD  Charme Hotel Alexander  10m  Remote Location  20m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 15-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/15-title-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 15-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:369px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(cOf(\"15-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"15-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Bormio  15  GU IC CI AR DI  Contents  VI A  CO LO N  NE  LL O  DI E  GO  Bormio  BAITA CLEMENTI HOTEL  PALACE HOTEL  CRISTALLO HOTEL  VIA  SS  IA  -V  NO  LA  MI  DA AD  MIRAMONTI PARK HOTEL  VIA I CH  N RO  ACCREDITATION CENTRE  E  RIV AR E- T IV POIN  DR  P TC  EXPLORE LIFE IN THE VILLAGE  Palace Hotel  Athletes and Team Officials  Unavailable area  Athletes and Team Officials, Guests and Press  0  Miramonti Park Hotel  Baita Clementi Hotel  Accreditation Centre Main Entry Secondary Entry Guest Pass Centre Village Plaza  Transport Mall  Main Dining Hall Residential Units  Pedestrian Screening Area  Resident Centre Fitness Centre  Materials Transfer Area  Recreational Areas Resident Laundries  Entrance/Exit  Medical Facility Prayer Room  Arrivals and Departures Service  TC  Transport Connect  Athlete365 House Mind Zone Doping Control Station  Access Control Point  Main Entry Address  Welcome to your village  P  NOC Dedicated Parking  TBD  Cristallo Hotel  Remote location  10m  20m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 16-title\" style=\"top:87px;left:21px;\" src=\"/milanocortina2026/en/static/_content/16-title-1.png\"/>\n\n      <img class=\"abs halfScaleC halfpulse animatedpulse 16-btn pointer\" onclick=\"Publish.goToPage(17)\" style=\"top:451px;left:-55px;\" src=\"/milanocortina2026/en/static/_content/11-btn-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(cOf(\"16-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"16-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Anterselva  16  Anterselva  TA  GARBERHOF HOTEL  RASUN DI SOTTO  ALPENHOF HOTEL  VI A  VA  LL  ED  ’A N  TE  RS  EL  VA  ST RA DA  PR OV  IN C  IA LE 44  ANTERSELVA BIATHLON ARENA 15KM  CLUSTER CONNECTION CENTRE (CCC)  TA  AUTENTIS HOTEL BRUNNERHOF HOTEL  EXPLORE LIFE IN THE VILLAGE  Garberhof Hotel  Athletes and Team Officials  Unavailable area  Athletes and Team Officials, Guests and Press  Transport Mall  TA  Transport for Athletes  Pedestrian Screening Area  0  TA  Alpenhof Hotel  Brunnerhof Hotel  Autentis Hotel  10m  Remote location  Main Entry (PSA) Cluster Connection Centre (CCC) Guest Pass Centre Main Dining Hall Residential Units Resident Centre Fitness Centre Recreational Areas Resident Laundries Medical Facility  Polyclinic  Prayer Room Materials Transfer Area  Entrance/Exit  Entry to Residental Units  Welcome to your village  Athlete365 House  ABA  Mind Zone  ABA  20m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 17-title\" style=\"top:107px;left:245px;\" src=\"/milanocortina2026/en/static/_content/17-title-1.png\"/>\n      <img class=\"abs halfScale 17-title\" style=\"top:177px;left:189px;\" src=\"/milanocortina2026/en/static/_content/17-title-2.png\"/>\n      <img class=\"abs halfScale 17-title\" style=\"top:581px;left:122px;\" src=\"/milanocortina2026/en/static/_content/17-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:633px; left:98px; width:176px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(19);\" style=\"top:671px; left:98px; width:176px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:709px; left:98px; width:176px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:749px; left:98px; width:176px; height:36px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:633px; left:321px; width:206px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(24);\" style=\"top:671px; left:321px; width:206px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(25);\" style=\"top:709px; left:321px; width:206px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:747px; left:321px; width:206px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(27);\" style=\"top:786px; left:321px; width:206px; height:22px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.staggerFromTo(cOf(\"17-title\"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Life in the Village  17  Life in the village  Find out what's happening in your Village. 18 Olympic Village services  23 Believe in Sport ambassadors  19 Athlete365 House  24 Pamper yourself with P&G  20 IOC AC election  25 Paying with Visa  22 A thlete365 x  26 Your Golden Moment  Powerade Mind Zone  Life in the village  27 Eating and drinking"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 18-title\" style=\"top:86px;left:23px;\" src=\"/milanocortina2026/en/static/_content/18-title-1.png\"/>\n      <img class=\"abs halfScale 18-title\" style=\"top:138px;left:23px;\" src=\"/milanocortina2026/en/static/_content/18-title-2.png\"/>\n      <img class=\"abs halfScale 18-title\" style=\"top:190px;left:23px;\" src=\"/milanocortina2026/en/static/_content/18-title-3.png\"/>\n      <img class=\"abs halfScale 18-sub\" style=\"top:253px;left:21px;\" src=\"/milanocortina2026/en/static/_content/18-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/milano-cortina2026/your-olympic-village-services-at-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 18-btn\" style=\"top:301px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/18-btn-1.png\"/>\n      </a>\n\n      <img class=\"abs halfScale 18-greenbox\" style=\"top:87px;left:302px;\" src=\"/milanocortina2026/en/static/_content/18-greenbox.png\" />\n      <img class=\"abs halfScale 18-bottom-bar-1\" style=\"top:832px;left:-35px;\" src=\"/milanocortina2026/en/static/_content/18-bottom-bar-1.png\" />\n\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:75px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-1.png\" />\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:199px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-2.png\" />\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:323px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-3.png\" />\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:447px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-4.png\" />\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:571px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-5.png\" />\n      <img class=\"abs halfScaleC 18-icon\" style=\"top:695px;left:275px;\" src=\"/milanocortina2026/en/static/_content/18-icon-6.png\" />\n\n      <img class=\"abs halfScale 18-text\" style=\"top:109px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-1.png\"/>\n      <img class=\"abs halfScale 18-text\" style=\"top:255px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-2.png\"/>\n      <img class=\"abs halfScale 18-text\" style=\"top:371px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-3.png\"/>\n      <img class=\"abs halfScale 18-text\" style=\"top:495px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-4.png\"/>\n      <img class=\"abs halfScale 18-text\" style=\"top:633px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-5.png\"/>\n      <img class=\"abs halfScale 18-text\" style=\"top:757px;left:417px;\" src=\"/milanocortina2026/en/static/_content/18-text-6.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"18-greenbox\"), 1, {opacity:0, x: 120}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"18-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"18-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)\n          .staggerFromTo(cOf(\"18-text\"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.9)\n          \n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Village services  Olympic Village services Here’s what you will find in your Olympic Village.  18  Medical services  Medical services will be available in each Village, with varying levels of service, including external locations supported by arranged transport. Accredited entourage members are eligible only in emergencies.  Fitness Centre  Gym with equipment tailored to the specific sports represented in the Village.  Find out more Laundry  Self-service laundry stocked with Dash Laundry Detergent, Lenor Fabric Conditioner and Lenor In-wash Scent Booster from P&G.  Resident Centre  Get assistance with any accommodation issues, including housekeeping requests, emergency maintenance and lost property.  Recreational area  Relax and have fun with a variety of entertainment activities.  Prayer room  A quiet space for meditation and worship.  Life in the village"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 19-title\" style=\"top:85px;left:20px;\" src=\"/milanocortina2026/en/static/_content/19-title-1.png\"/>\n      <img class=\"abs halfScale 19-title\" style=\"top:138px;left:20px;\" src=\"/milanocortina2026/en/static/_content/19-title-2.png\"/>\n      <img class=\"abs halfScale 19-title\" style=\"top:201px;left:20px;\" src=\"/milanocortina2026/en/static/_content/19-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/milano-cortina2026/everything-you-need-to-know-about-athlete365-house-at-milano-cortina-2026 \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 19-btn\" style=\"top:791px;left:-21px;\" src=\"/milanocortina2026/en/static/_content/19-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 House  19  Athlete365 House Connect with other athletes, access support programmes, learn about key topics and vote in the IOC Athletes’ Commission election – all at Athlete365 House! Thoughtfully designed for you to get involved in rewarding activities, share your voice, create memories with other athletes, and collect limitededition freebies, Athlete365 House will be in every Village at Milano Cortina 2026. With six areas to explore, here’s what you can expect:  Play  Empower  Celebrate Commemorate your Games experience with souvenir photos  Life in the village  Vote in the IOC Athletes’ Commission election  Connect  Learn about the prevention of competition manipulation and antidoping  Find out more  Act  Play PinQuest and win special prizes Join the Athlete365 community, access our exclusive offers and learn about the Olympic Solidarity opportunities available to you  Excite Watch live competitions with other athletes"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 20-title\" style=\"top:151px;left:19px;\" src=\"/milanocortina2026/en/static/_content/20-title-1.png\"/>\n      <img class=\"abs halfScale 20-title\" style=\"top:218px;left:18px;\" src=\"/milanocortina2026/en/static/_content/20-title-2.png\"/>\n      <img class=\"abs halfScale 20-title\" style=\"top:299px;left:21px;\" src=\"/milanocortina2026/en/static/_content/20-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/milano-cortina2026/ioc-athletes-commission-election-milano-cortina-2026 \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 3-btn\" style=\"top:778px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/20-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | IOC Athletes' Commission election  Contents  Vote in the IOC Athletes’ Commission Election Have your say in who represents you within the Olympic Movement. Two athletes from two different sports will be elected to the IOC Athletes’ Commission (AC) at Milano Cortina 2026. All accredited athletes (Aa) are eligible to vote – don’t miss this chance to use your voice.  What is the IOC AC? The IOC AC’s mission is to represent you within the Olympic Movement, support you so they can succeed in your sporting and non-sporting careers, and empower the global network of athlete representatives.  Who is standing? There are 11 candidates standing in the election, representing 11 National Olympic Committees and five sports. Find out more about your candidates on the next page.  When and where can I vote? Election dates: 30 January–18 February Location: Voting booths at Athlete365 House in each Village  Find out more Life in the village  20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 21-title\" style=\"top:151px;left:19px;\" src=\"/milanocortina2026/en/static/_content/21-title-1.png\"/>\n\n      <img class=\"abs halfScale 21-candidate\" style=\"top:255px;left:21px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-1.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:255px;left:118px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-2.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:255px;left:216px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-3.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:255px;left:314px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-4.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:255px;left:411px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-5.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:274px;left:509px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-6.png\"/>\n\n      <img class=\"abs halfScale 21-candidate\" style=\"top:530px;left:21px;\" src=\"/milanocortina2026/en/static/_content/21-line.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:536px;left:21px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-7.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:536px;left:118px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-8.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:536px;left:216px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-9.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:536px;left:314px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-10.png\"/>\n      <img class=\"abs halfScale 21-candidate\" style=\"top:536px;left:411px;\" src=\"/milanocortina2026/en/static/_content/21-candidate-11.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"21-candidate\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | IOC Athletes' Commission election  21  Meet your candidates biathlon  Bobsleigh  EST  KOR  Johanna TALIHÄRM  Yunjong WON  SUI  TLS  Dario cologna  Life in the village  Yohan GONcALVES GOUTT  Curling  Skating  NOR  Magnus NEDREGOTTEN  FIN  Ilkka HEROLA  CHN  Cong HAN  HUN  Ádám KÓNYA  Skiing  UKR  KAZ  Oleksandr ABRAMENKO  Zhanbota ALDABERGENOVA  CAN  Marielle THOMPSON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 22-title\" style=\"top:86px;left:21px;\" src=\"/milanocortina2026/en/static/_content/22-title-1.png\"/>\n      <img class=\"abs halfScale 22-title\" style=\"top:137px;left:21px;\" src=\"/milanocortina2026/en/static/_content/22-title-2.png\"/>\n      <img class=\"abs halfScale 22-sub\" style=\"top:200px;left:22px;\" src=\"/milanocortina2026/en/static/_content/22-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/news/mentally-fit/relax-and-recharge-at-the-athlete365-x-powerade-mind-zone \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 22-btn\" style=\"top:418px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/22-btn-1.png\"/>\n      </a>\n\n      <a href=\"https://www.olympics.com/athlete365/offers/mentally-fit/free-mindfulness-app-subscription\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 22-btn\" style=\"top:390px;left:436px;\" src=\"/milanocortina2026/en/static/_content/22-btn-2.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"22-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 X Powerade Mind Zone  22  Athlete365 x Powerade Mind Zone Relax, recharge and mentally prepare to compete at your best. First introduced at Paris 2024, the Athlete365 x Powerade Mind Zone is a groundbreaking initiative that helps you prioritise your mental health during the Olympic Games. • Relax with a virtual reality mindfulness experience* • Disconnect and inspire your creativity with art activities • Unwind and de-stress with breathing exercises • Have a confidential chat with a qualified IOC safeguarding officer** Delivered in partnership with Worldwide Olympic Partner Coca-Cola, the Mind Zone is also stocked with Powerade products to aid your recovery.  Did you know? You can get a free one-year premium subscription to a leading mindfulness app with Athlete365.  Access offer  Find out more *Mind Zone in Bormio will not have the VR experience. **Mind Zone in Bormio will not be staffed but contact information for mental health and safeguarding support will be available.  Life in the village"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 23-title\" style=\"top:126px;left:23px;\" src=\"/milanocortina2026/en/static/_content/23-title-1.png\"/>\n      <img class=\"abs halfScale 23-title\" style=\"top:178px;left:22px;\" src=\"/milanocortina2026/en/static/_content/23-title-2.png\"/>\n      <img class=\"abs halfScale 23-sub\" style=\"top:240px;left:20px;\" src=\"/milanocortina2026/en/static/_content/23-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 23-img\" style=\"top:252px;left:243px;\" src=\"/milanocortina2026/en/static/_content/23-img-1.png\"/>\n      <img class=\"abs halfScaleC 23-img\" style=\"top:252px;left:348px;\" src=\"/milanocortina2026/en/static/_content/23-img-2.png\"/>\n      <img class=\"abs halfScaleC 23-img\" style=\"top:252px;left:453px;\" src=\"/milanocortina2026/en/static/_content/23-img-3.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/believeinsport/meet-your-believe-in-sport-ambassadors-for-milano-cortina-2026 \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 23-btn\" style=\"top:531px;left:-86px;\" src=\"/milanocortina2026/en/static/_content/23-btn-1.png\"/>\n      </a>\n\n      <a href=\"https://www.olympics.com/athlete365/topics/believeinsport?nxtPpath=believeinsport\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 23-btn\" style=\"top:577px;left:-77px;\" src=\"/milanocortina2026/en/static/_content/23-btn-2.png\"/>\n      </a>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/believeinsport/prevention-of-competition-manipulation-international-federations-directory \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 23-btn\" style=\"top:764px;left:-42px;\" src=\"/milanocortina2026/en/static/_content/23-btn-3.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"23-img\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.2)\n          .fromTo(cOf(\"23-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Believe in Sport ambassadors  Meet your Believe in Sport ambassadors The Believe in Sport campaign raises awareness about the threat of competition manipulation. As part of the IOC’s Believe in Sport campaign, three ambassadors have been chosen for Milano Cortina 2026: Mark Fraser, Yura Min and Dominik Windisch. They will be present at the Believe in Sport booth in Athlete365 House in Milan and Cortina from 30 January to 23 February. Head down to the booth to find out more about the prevention of competition manipulation and have a go at an interactive game to take home a special souvenir.  Learn more about your ambassadors Learn more about Believe in Sport We want you to feel confident in spotting the warning signs and know exactly what you can do to protect the integrity of sport. To find out what your sport is doing to prevent competition manipulation, head to our International Federations Directory.  Access the directory  Life in the village  23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 24-title\" style=\"top:142px;left:21px;\" src=\"/milanocortina2026/en/static/_content/24-title-1.png\"/>\n      <img class=\"abs halfScale 24-title\" style=\"top:193px;left:21px;\" src=\"/milanocortina2026/en/static/_content/24-title-2.png\"/>\n      <img class=\"abs halfScale 24-title\" style=\"top:245px;left:21px;\" src=\"/milanocortina2026/en/static/_content/24-title-3.png\"/>\n      <img class=\"abs halfScale 24-sub\" style=\"top:308px;left:22px;\" src=\"/milanocortina2026/en/static/_content/24-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/news/milano-cortina2026/calling-all-parent-athletes-aiming-for-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 24-btn\" style=\"top:760px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/24-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"24-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Pamper yourself with P&G  24  Pamper yourself with P&G P&G’s leading brands are here to help you feel your best during the Games. P&G Champions Clubhouse For athletes in the Milan Olympic Village, head to the P&G Champions Clubhouse to treat yourself to beauty and grooming services, take part in gaming competitions and cultural celebrations with fellow athletes, and receive exclusive giveaways.  Pampers Kit for parents  Are you an athlete with a baby or young child travelling with you to the Games? Pick up your Pampers Kit, designed to support your family during your stay at the Games with high-quality nappies/diapers, wipes and a few other surprises for your little one. If you haven’t done so already, sign up here to register your interest.  Register here  Life in the village  Athlete Welcome Kit  To welcome you to Milano Cortina 2026, all athletes will receive a thoughtfully curated Athlete Welcome Kit, packed with premium products to ensure you feel your best as you compete on the world stage."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 25-title\" style=\"top:158px;left:21px;\" src=\"/milanocortina2026/en/static/_content/25-title-1.png\"/>\n      <img class=\"abs halfScale 25-sub\" style=\"top:220px;left:22px;\" src=\"/milanocortina2026/en/static/_content/25-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.staggerFromTo(cOf(\"25-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"25-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Paying with Visa  Paying with Visa As part of Visa’s longstanding partnership with the Olympic and Paralympic Games, Milano Cortina 2026 accepts only Visa for card payments, along with cash, at Olympic venues and Villages to pay for food, beverages and official licensed products.  Get ready for the Games. Contact your bank and request a Visa card now.  Life in the village  25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 26-title\" style=\"top:557px;left:21px;\" src=\"/milanocortina2026/en/static/_content/26-title-1.png\"/>\n      <img class=\"abs halfScale 26-sub\" style=\"top:621px;left:22px;\" src=\"/milanocortina2026/en/static/_content/26-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"26-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Your Golden Moment  mark Your Golden Moment Celebrate your time at the Games with a Corona Golden Bottle. For athletes in the Milan and Cortina Villages, head to the Corona Greenroom to relax before competition, recharge afterwards, and celebrate your achievements. Here, you can customise and pick up your Corona Golden Bottle, a unique symbol of  Life in the village  your journey, ready to be engraved with the golden moment that defined your Games. If you are staying in Predazzo, Livigno, Bormio, or Anterselva, you can personalise your Golden Bottle online and have it delivered to you. Stay tuned.  26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 27-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/27-title-1.png\"/>\n      <img class=\"abs halfScale 27-sub\" style=\"top:148px;left:22px;\" src=\"/milanocortina2026/en/static/_content/27-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.staggerFromTo(cOf(\"27-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"27-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Eating and drinking  Eating and drinking Your food and beverage options at the Games have been carefully designed to offer you high-quality meals tailored to your dietary and nutritional requirements.  Olympic Villages • The Main Dining Areas in each Village will operate for 24 hours a day • Specific menus available for breakfast, lunch and dinner • Options will rotate over five days and offer a diverse selection • Vegetarian, vegan and glutenfree options always available • Water, isotonic drinks, juices and soft drinks from CocaCola available throughout the Village  Competition venues • The Athletes’ Lounge at each venue will offer light refreshments • Meals will be provided if you’re at the venue for more than four hours • Enhanced meals will be provided for certain disciplines • Water and Powerade available on field of play; other CocaCola products available in Athletes’ Lounge Life in the village  27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 28-title\" style=\"top:107px;left:124px;\" src=\"/milanocortina2026/en/static/_content/28-title-1.png\"/>\n      <img class=\"abs halfScale 28-title\" style=\"top:176px;left:115px;\" src=\"/milanocortina2026/en/static/_content/28-title-2.png\"/>\n      <img class=\"abs halfScale 28-title\" style=\"top:580px;left:76px;\" src=\"/milanocortina2026/en/static/_content/28-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:633px; left:57px; width:157px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:671px; left:57px; width:157px; height:37px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(31);\" style=\"top:721px; left:57px; width:157px; height:24px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(32);\" style=\"top:759px; left:57px; width:157px; height:38px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:633px; left:231px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:672px; left:231px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(35);\" style=\"top:709px; left:231px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(36);\" style=\"top:746px; left:231px; width:168px; height:22px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(37);\" style=\"top:633px; left:406px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:672px; left:406px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(39);\" style=\"top:709px; left:406px; width:168px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:746px; left:406px; width:168px; height:22px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Maximising your Games experience  28  MAXIMISING YOUR GAMES EXPERIENCE  Make the most of your time at Milano Cortina 2026. 29 Airbnb500  33 Social media verification 37 PinQuest  30 Olympic Edition  34 Online abuse protection 38 How to access tickets  Samsung phone  31 Athlete Moment 32 Capture your  Olympic experience  Maximising your Games experience  35 Athlete365 app  39 Opening Ceremony  36 Athlete365 Learning  40 Get Set - Train Smarter"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScaleC 29-relax\" style=\"top:189px;left:184px;\" src=\"/milanocortina2026/en/static/_content/29-relax-1.png\" />\n      <div id=\"29-sig\" class=\"abs noOverflow\" style=\"top:171px;left:219px;width:80px;height:73px;background-color:#e6dae6;\"></div>\n\n      <img class=\"abs halfScale 29-title\" style=\"top:226px;left:21px;\" src=\"/milanocortina2026/en/static/_content/29-title-1.png\"/>\n      <img class=\"abs halfScale 29-title\" style=\"top:281px;left:21px;\" src=\"/milanocortina2026/en/static/_content/29-title-2.png\"/>\n      <img class=\"abs halfScale 29-title\" style=\"top:330px;left:21px;\" src=\"/milanocortina2026/en/static/_content/29-title-3.png\"/>\n\n      <img class=\"abs halfScaleC 29-scribble\" style=\"top:224px;left:132px;\" src=\"/milanocortina2026/en/static/_content/29-scribble-1.png\" />\n\n      <a href=\"https://www.olympics.com/athlete365/articles/airbnb500/the-airbnb500\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-btn\" style=\"top:377px;left:261px;\" src=\"/milanocortina2026/en/static/_content/29-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"29-scribble\"), 0.5, {scale: 0}, {scale:0.45, ease: Back.easeOut.config(1.2)}, 2.5)\n          .fromTo(idOf(\"29-sig\"), 0.8, {width:80,x:0}, {width: 0,x:80, ease: Power2.easeOut}, 3)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Airbnb500  Rela  READY, SET, GO WITH a USD 500 AIRBNB GRANT  x  29  Take a moment to rest and recover after the Games with a USD 500 Airbnb Travel Grant, available only to Olympians and Paralympians competing at Milano Cortina 2026. Claim your grant from 30 January to 20 April 2026 by registering online or going to Athlete365 House in your Olympic Village. Additional terms and conditions apply.  FIND OUT MORE  Maximising your Games experience"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 30-title\" style=\"top:128px;left:21px;\" src=\"/milanocortina2026/en/static/_content/30-title-1.png\"/>\n      <img class=\"abs halfScale 30-sub\" style=\"top:191px;left:21px;\" src=\"/milanocortina2026/en/static/_content/30-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:425px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-1.png\" />\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:488px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-2.png\" />\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:548px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-3.png\" />\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:609px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-4.png\" />\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:670px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-5.png\" />\n      <img class=\"abs halfScaleC 30-icon\" style=\"top:731px;left:356px;\" src=\"/milanocortina2026/en/static/_content/30-icon-6.png\" />\n\n      <img class=\"abs halfScale 30-text\" style=\"top:464px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-1.png\"/>\n      <img class=\"abs halfScale 30-text\" style=\"top:534px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-2.png\"/>\n      <img class=\"abs halfScale 30-text\" style=\"top:595px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-3.png\"/>\n      <img class=\"abs halfScale 30-text\" style=\"top:656px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-4.png\"/>\n      <img class=\"abs halfScale 30-text\" style=\"top:716px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-5.png\"/>\n      <img class=\"abs halfScale 30-text\" style=\"top:763px;left:446px;\" src=\"/milanocortina2026/en/static/_content/30-text-6.png\"/>\n\n      <a href=\"https://athlete365.org/samsung-offer\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-btn\" style=\"top:357px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/33-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"30-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"30-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)\n          .staggerFromTo(cOf(\"30-text\"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.5)\n          \n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Edition Samsung phone  30  YOUR OLYMPIC EDITION PHONE All athletes competing at Milano Cortina 2026 will receive an exclusive Samsung Galaxy Z Flip7 Olympic Edition phone. As a Worldwide Olympic Partner for nearly 30 years, Samsung is proud to bring you a Samsung Galaxy Z Flip7 Olympic Edition phone – designed exclusively for athletes at Milano Cortina 2026. To help you make the most of your time at the Games, your phone will come with several essential apps pre-installed, including including Athlete365, Milano Cortina 2026 and Galaxy Athlete Card. You can also use a free eSIM with data, calls and texts upon activation.  FIND OUT MORE  What makes it special?  Exclusive design and user experience  Samsung Galaxy AI  Olympic applications  Special accessories  2-year global warranty  Coca-Cola free drink key & discount coupons  Maximising your Games experience"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 31-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/31-title-1.png\"/>\n      <img class=\"abs halfScale 31-title\" style=\"top:138px;left:21px;\" src=\"/milanocortina2026/en/static/_content/31-title-2.png\"/>\n      <img class=\"abs halfScale 31-title\" style=\"top:190px;left:21px;\" src=\"/milanocortina2026/en/static/_content/31-title-3.png\"/>\n      <img class=\"abs halfScale 31-sub\" style=\"top:252px;left:21px;\" src=\"/milanocortina2026/en/static/_content/31-sub-1.png\"/>\n      <img class=\"abs halfScale 31-sub\" style=\"top:292px;left:21px;\" src=\"/milanocortina2026/en/static/_content/31-sub-2.png\"/>\n\n      <a href=\"https://athlete365.org/athlete-moment-mico\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-btn\" style=\"top:739px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/33-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"31-sub\"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete Moment  31  Celebrate with loved ones around the world Do you have family and friends who can’t be at the Games? Connect with them after your event with the Athlete Moment, presented by TCL. How does it work? 1S  ign up and share your private link with loved ones 2 Loved ones join video call at specified time 3 Celebrate on screen immediately after your event  Is my sport included? The Athlete Moment will be available for all sports at Milano Cortina 2026. If you’re competing in curling or ice hockey, it will be available from the quarter-finals onwards. For every other sport, it will be available during all sessions.  FIND OUT MORE  Maximising your Games experience  How do I apply?  Fill in the form via the link below to sign up – applications will open in January."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 32-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/32-title-1.png\"/>\n      <img class=\"abs halfScale 32-title\" style=\"top:138px;left:21px;\" src=\"/milanocortina2026/en/static/_content/32-title-2.png\"/>\n      <img class=\"abs halfScale 32-sub\" style=\"top:200px;left:21px;\" src=\"/milanocortina2026/en/static/_content/32-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"32-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"32-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Capture your Olympic experience  Contents  32  Capture your Olympic experience Have a professional headshot taken and get access to photos of yourself competing at the Olympic Games.  Athlete headshots All athletes are required to get a professional headshot taken in the studio in your Olympic Village or competition venue. Your picture will be used for:  There will also be an audio recording during the session to ensure your name is pronounced properly during commentary. The schedules and location will be communicated for each discipline.  • TV graphics • Public scoreboards • Website biographies • Social media  Competition images The Athlete365 app gives you direct access to all professional photos taken of you at Games-time. You will also get access to your headshot and the Samsung Victory Selfie.  Make sure you get your headshot taken at least two days before your first competition.  Maximising your Games experience  All photos on the app are yours to keep and share on social media."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 33-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/33-title-1.png\"/>\n      <img class=\"abs halfScale 33-sub\" style=\"top:149px;left:21px;\" src=\"/milanocortina2026/en/static/_content/33-sub-1.png\"/>\n      \n      <img class=\"abs halfScale 33-box\" style=\"top:542px;left:18px;\" src=\"/milanocortina2026/en/static/_content/33-box-1.png\"/>\n      <img class=\"abs halfScale 33-box\" style=\"top:629px;left:18px;\" src=\"/milanocortina2026/en/static/_content/33-box-2.png\"/>\n      <img class=\"abs halfScale 33-box\" style=\"top:715px;left:18px;\" src=\"/milanocortina2026/en/static/_content/33-box-3.png\"/>\n\n      <img class=\"abs halfScale 33-image\" style=\"top:209px;left:228px;\" src=\"/milanocortina2026/en/static/_content/33-image-1.png\"/>\n\n      <a href=\"https://athlete365.org/social-media-verification-mico\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-btn\" style=\"top:390px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/33-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim.fromTo(cOf(\"33-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"33-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"33-box\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Social media verification  Get verified on social media Some of the most popular social media platforms are offering verification for athletes competing at Milano Cortina 2026. Having a verified account on social media shows your audience that they are engaging with the real you and helps elevate your personal brand. Athletes at Milano Cortina 2026 will be able to request verification through Athlete365.  find out more  1 2 3  Log in to Athlete365  Fill in the form  Get verified  Maximising your Games experience  33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 34-title\" style=\"top:85px;left:22px;\" src=\"/milanocortina2026/en/static/_content/34-title-1.png\"/>\n      <img class=\"abs halfScale 34-title\" style=\"top:137px;left:21px;\" src=\"/milanocortina2026/en/static/_content/34-title-2.png\"/>\n      <img class=\"abs halfScale 34-sub\" style=\"top:200px;left:20px;\" src=\"/milanocortina2026/en/static/_content/34-sub-1.png\"/>\n      \n\n      <a href=\"https://athlete365.org/cyber-abuse\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 29-btn\" style=\"top:331px;left:175px;\" src=\"/milanocortina2026/en/static/_content/33-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.staggerFromTo(cOf(\"34-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"34-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Online abuse protection  Protecting you from abuse on social media A monitoring system powered by artificial intelligence (AI) will help defend you from online abuse on social media during the Games. How does the service work? The system uses AI to identify abusive comments directed at athletes on public-facing accounts in more than 40 languages and flag them for removal. How effective is the service? At Paris 2024, the monitoring system: 	Analysed 2.4m posts covering 20,000 accounts 	Identified 150,000+ posts as potentially abusive 	Verified 10,000+ posts as abusive and flagged for removal Who is covered? All competing athletes are automatically covered. You can opt out at any time. Accredited entourage members are also able to opt in.  Maximising your Games experience  When is the service in place? The service will start on 4 February 2026 and end on 24 February 2026.  Find out more  34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 35-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/35-title-1.png\"/>\n      <img class=\"abs halfScale 35-title\" style=\"top:137px;left:21px;\" src=\"/milanocortina2026/en/static/_content/35-title-2.png\"/>\n      <img class=\"abs halfScale 35-sub\" style=\"top:200px;left:21px;\" src=\"/milanocortina2026/en/static/_content/35-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 35-icon\" style=\"top:328px;left:-4px;\" src=\"/milanocortina2026/en/static/_content/35-icon-1.png\" />\n      <img class=\"abs halfScaleC 35-icon\" style=\"top:478px;left:-4px;\" src=\"/milanocortina2026/en/static/_content/35-icon-2.png\" />\n      <img class=\"abs halfScaleC 35-icon\" style=\"top:627px;left:-4px;\" src=\"/milanocortina2026/en/static/_content/35-icon-3.png\" />\n      <img class=\"abs halfScaleC 35-icon\" style=\"top:478px;left:285px;\" src=\"/milanocortina2026/en/static/_content/35-icon-4.png\" />\n      <img class=\"abs halfScaleC 35-icon\" style=\"top:627px;left:285px;\" src=\"/milanocortina2026/en/static/_content/35-icon-5.png\" />\n\n      <img class=\"abs halfScale 35-text\" style=\"top:389px;left:130px;\" src=\"/milanocortina2026/en/static/_content/35-text-1.png\"/>\n      <img class=\"abs halfScale 35-text\" style=\"top:529px;left:130px;\" src=\"/milanocortina2026/en/static/_content/35-text-2.png\"/>\n      <img class=\"abs halfScale 35-text\" style=\"top:669px;left:130px;\" src=\"/milanocortina2026/en/static/_content/35-text-3.png\"/>\n      <img class=\"abs halfScale 35-text\" style=\"top:521px;left:419px;\" src=\"/milanocortina2026/en/static/_content/35-text-4.png\"/>\n      <img class=\"abs halfScale 35-text\" style=\"top:678px;left:419px;\" src=\"/milanocortina2026/en/static/_content/35-text-5.png\"/>\n\n      <a href=\"http://athlete365.org/download \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 24-btn\" style=\"top:787px;left:-78px;\" src=\"/milanocortina2026/en/static/_content/35-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.staggerFromTo(cOf(\"35-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"35-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .staggerFromTo(cOf(\"35-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n          .staggerFromTo(cOf(\"35-text\"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.7)\n          \n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 app  35  Download the Athlete365 app Everything that Athlete365 has to offer, right at your fingertips. Your go-to destination for our practical resources, learning opportunities and exclusive offers, the Athlete365 app is split into five sections:  Home The latest news from Athlete365.  For you Log in to access a personalised feed based on your interests.  Learning Easy access to all of our bespoke educational courses, with insight from experts and Worldwide Olympic Partners.  Download the Athlete365 app now Maximising your Games experience  Games Everything you need to know before, during and after your time at Milano Cortina 2026.  Your network Keep up to date with the global athlete community and meet your representatives."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 36-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/36-title-1.png\"/>\n      <img class=\"abs halfScale 36-sub\" style=\"top:148px;left:22px;\" src=\"/milanocortina2026/en/static/_content/36-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/learning\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 36-btn\" style=\"top:482px;left:-93px;\" src=\"/milanocortina2026/en/static/_content/36-btn-1.png\"/>\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.staggerFromTo(cOf(\"36-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"36-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 Learning  Athlete365 Learning Empower yourself on and off the field of play with new skills, knowledge and expert advice. Athlete365 Learning is a bespoke educational platform designed for athletes and their entourage, with insight from experts and Worldwide Olympic Partners to help you on your journey to the Olympic Games. Our courses cover a wide range of important topics, from maximising your performance, to improving your mental strength and building a winning personal brand. Upon completion of each course, you will receive an official IOC Certificate.  Start your Athlete365 Learning journey  Maximising your Games experience  36"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 37-title\" style=\"top:111px;left:20px;\" src=\"/milanocortina2026/en/static/_content/37-title-1.png\"/>\n      <img class=\"abs halfScale 37-sub\" style=\"top:222px;left:20px;\" src=\"/milanocortina2026/en/static/_content/37-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim.staggerFromTo(cOf(\"37-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"37-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | PinQuest  37  Start your PinQuest journey today!  Win limited-edition Milano Cortina 2026 souvenirs! PinQuest is a digital game that invites you to test your Olympic knowledge, challenge other athletes and athletes’ entourage members, interact with IOC Athletes’ Commission members – and win an exclusive Milano Cortina 2026 pin collection (and more)!  How do I play?  What can I win?  Download the PinQuest app from your store and sign in using your Olympic ID.  If you accumulate 10,000 points, you will unlock an exclusive collection of Milano Cortina 2026 pins. There are also several other special prizes available, including Allianz's special pin!  When you're up and running, simply explore the virtual 3D map, answer quiz questions and challenge other players.  Maximising your Games experience  How do I collect my prizes? Simply head to the PinQuest desk at Athlete365 House to claim."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 38-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/38-title-1.png\"/>\n      <img class=\"abs halfScale 38-sub\" style=\"top:148px;left:22px;\" src=\"/milanocortina2026/en/static/_content/38-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/news/milano-cortina2026/milano-cortina-2026-ticket-information-for-athletes\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 38-btn\" style=\"top:772px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/38-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"38-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | How to access tickets  How to access tickets Want to secure tickets for yourself and your loved ones? Here are your ticketing options. Athletes’ Friends & Family Ticketing Programme Purchase two tickets per session in which you are competing. • Preliminary round tickets available in early February • Intermediate round tickets available between rounds • Use your accreditation number to purchase on dedicated web shop  Different Discipline Athletes Programme Support your fellow athletes free of charge. • For outdoor venues, you can enter using only your accreditation • For indoor venues, you can request one ticket per day on a first-come first-served basis, and must bring both your ticket and accreditation • Dedicated web shop open in early February  FIND OUT MORE  Maximising your Games experience  38"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 39-title\" style=\"top:85px;left:20px;\" src=\"/milanocortina2026/en/static/_content/39-title-1.png\"/>\n      <img class=\"abs halfScale 39-sub\" style=\"top:148px;left:20px;\" src=\"/milanocortina2026/en/static/_content/39-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"39-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Opening Ceremony  39  Opening Ceremony A new vision for the Opening Ceremony will be in place at Milano Cortina 2026. Taking part in the Opening Ceremony is one of the most memorable moments of the Olympic Games.  Milano Cortina 2026 will take place across four locations: Milan, Cortina, Livigno and Predazzo.  Dedicated transport will be provided within each cluster, taking you from your Village to your Opening Ceremony.  To ensure the maximum number of athletes get to enjoy this once-in-a-lifetime experience, the Opening Ceremony of  If you want to take part in the Opening Ceremony, you will parade in the cluster where you are competing.  Contact your NOC, e.g. your Chef de Mission, for more information.  Maximising your Games experience"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 40-title\" style=\"top:202px;left:20px;\" src=\"/milanocortina2026/en/static/_content/40-title-1.png\"/>\n      <img class=\"abs halfScale 40-sub\" style=\"top:265px;left:20px;\" src=\"/milanocortina2026/en/static/_content/40-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"40-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Get Set - Train Smarter  Google Play Store  App Store  Get Set – Train Smarter The Get Set – Train Smarter app helps incorporate injury prevention into your exercise routines using scientifically proven methods – allowing you to perform at your best and stay injury free when you need it the most. Prevent injuries with effective and evidence-based workout routines Exercises included for 55 sports – including 15 winter disciplines Focus on the body part of your choice  Get Set is available in 11 languages: English, French, Spanish, Russian, German, Norwegian, Chinese, Korean, Finnish, Italian and Slovenian.  Maximising your Games experience  40"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n\n      <img class=\"abs halfScale 41-title\" style=\"top:107px;left:231px;\" src=\"/milanocortina2026/en/static/_content/41-title-1.png\"/>\n      <img class=\"abs halfScale 41-title\" style=\"top:177px;left:248px;\" src=\"/milanocortina2026/en/static/_content/41-title-2.png\"/>\n      <img class=\"abs halfScale 41-title\" style=\"top:580px;left:103px;\" src=\"/milanocortina2026/en/static/_content/41-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(42);\" style=\"top:633px; left:111px; width:196px; height:38px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(43);\" style=\"top:685px; left:111px; width:196px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(44);\" style=\"top:723px; left:111px; width:196px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(45);\" style=\"top:760px; left:111px; width:196px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(46);\" style=\"top:799px; left:111px; width:196px; height:22px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(47);\" style=\"top:633px; left:318px; width:196px; height:38px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:685px; left:318px; width:196px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(49);\" style=\"top:723px; left:318px; width:196px; height:22px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(50);\" style=\"top:760px; left:318px; width:196px; height:22px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.staggerFromTo(cOf(\"41-title\"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);\n          setTimeout(function(){\n            addContentLinks();\n          },2000)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Need to know  41  NEED TO KNOW  Essential information for a stress-free Games. 42 Getting to your  47 P revention of  43 How to seek help  48 Anti-doping  44 Social media guidelines  49 Sustainability  45 Athlete Expression  50 Departures  competition venue  46 Commercial opportunities NEED TO KNOW  competition manipulation"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 42-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/42-title-1.png\"/>\n      <img class=\"abs halfScale 42-title\" style=\"top:137px;left:21px;\" src=\"/milanocortina2026/en/static/_content/42-title-2.png\"/>\n      <img class=\"abs halfScale 42-sub\" style=\"top:200px;left:20px;\" src=\"/milanocortina2026/en/static/_content/42-sub-1.png\"/>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"42-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Getting to your competition venue  42  Getting to your competition venue Average travel times between each Olympic Village and competition venue.  MILAN Venue  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Milano Santagiulia Ice Hockey Arena  7.4  20  45  Milano Rho Ice Hockey Arena  29.1  45  60  Milano Ice Skating Arena  8  30  45  Milano Speed Skating Stadium  29.1  45  60  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  7  25  30  CORTINA Venue Tofane Alpine Skiing Centre Cortina Sliding Centre  5  15  15  Cortina Curling Olympic Stadium  6  15  15  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Predazzo Ski Jumping Stadium  3  11  35  Tesero Cross-Country Skiing Stadium  8  16  40  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Livigno Snow Park  1  7  8  Livigno Aerials & Moguls Park  3  13  16  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  1  7  8  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  17  25  30  PREDAZZO Venue  LIVIGNO Venue  BORMIO Venue Stelvio Ski Centre  ANTERSELVA Venue Anterselva Biathlon Arena  NEED TO KNOW  Travel Time: Minutes TA: Transport for Athletes TP: Public transport"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 43-title\" style=\"top:165px;left:21px;\" src=\"/milanocortina2026/en/static/_content/43-title-1.png\"/>\n      <img class=\"abs halfScale 43-title\" style=\"top:216px;left:21px;\" src=\"/milanocortina2026/en/static/_content/43-title-2.png\"/>\n      <img class=\"abs halfScale 43-sub\" style=\"top:279px;left:22px;\" src=\"/milanocortina2026/en/static/_content/43-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/safesport/how-to-seek-help-at-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 43-btn\" style=\"top:385px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/43-btn-1.png\"/>\n      </a>\n      <a href=\"https://www.olympics.com/athlete365/offers/mentally-fit/access-the-mentally-fit-helpline\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 43-btn\" style=\"top:400px;left:273px;\" src=\"/milanocortina2026/en/static/_content/43-btn-2.png\"/>\n      </a>\n      <a href=\"https://ioc.integrityline.org/\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 43-btn\" style=\"top:537px;left:275px;\" src=\"/milanocortina2026/en/static/_content/43-btn-3.png\"/>\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:647px;left:367px;width:189px;height:19px\">\n        <a href=\"mailto:safeguardingofficer@olympic.org\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:784px;left:421px;width:151px;height:12px\">\n        <a href=\"mailto:safeguardingofficer@olympic.org\"></a>\n      </div>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.staggerFromTo(cOf(\"43-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"43-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | How to seek help  How to seek help Whether you find yourself struggling or have seen something that doesn't feel right, here's how to find support. No pressure, no judgement – just someone who’s got your back. FIND OUT MORE  43  Athlete365 Mind Zone: Visit the Mind Zone in your Olympic Village* for well-being and safeguarding support from qualified IOC Safeguarding Officers.  The Mentally Fit helpline: A confidential 24-hour counselling service with professional support in 70 languages. Available to all Olympians at Milano Cortina 2026 for four years.  CONTACT THE MENTALLY FIT HELPLINE  IOC Integrity Hotline: File an online report relating to harassment/ abuse or competition manipulation – you can choose to remain anonymous if you wish.  CONTACT THE IOC INTEGRITY HOTLINE  Email: Reach out to the IOC Safeguarding Officers at safeguardingofficer@olympic.org.  EMERGENCY SERVICES: In case of an emergency, call 112 for the police, ambulance or fire brigade. *For safeguarding support in Bormio, please contact safeguardingofficer@olympic.org. For mental health support, visit the polyclinic.  NEED TO KNOW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 44-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/44-title-1.png\"/>\n      <img class=\"abs halfScale 44-sub\" style=\"top:148px;left:22px;\" src=\"/milanocortina2026/en/static/_content/44-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/smg/milano-cortina-2026-social-media-guidelines\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 44-btn\" style=\"top:765px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/44-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.staggerFromTo(cOf(\"44-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"44-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Social media guidelines  Social media guidelines Milano Cortina 2026 offers more opportunities to engage with your followers than any previous Olympic Winter Games.  You are encouraged to share your Olympic experience with your friends, family and supporters. The IOC social and digital media guidelines set out exactly where you are able to capture content and what you can share on your social media accounts or other channels. You will need to follow the guidelines from 30 January to 24 February. The rules on prohibited content still apply after this period.  Why do these guidelines exist? The guidelines allow you to share your experience at the Games while protecting the rights of IOC Media Rights-Holders. Access the guidelines and FAQs for athletes and other accredited individuals:  FIND OUT MORE  NEED TO KNOW  44"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 45-title\" style=\"top:447px;left:21px;\" src=\"/milanocortina2026/en/static/_content/45-title-1.png\"/>\n      <img class=\"abs halfScale 45-title\" style=\"top:498px;left:21px;\" src=\"/milanocortina2026/en/static/_content/45-title-2.png\"/>\n      <img class=\"abs halfScale 45-sub\" style=\"top:562px;left:21px;\" src=\"/milanocortina2026/en/static/_content/45-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/athlete-expression/athlete-expression-guidelines-for-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 45-btn\" style=\"top:771px;left:-57px;\" src=\"/milanocortina2026/en/static/_content/45-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.staggerFromTo(cOf(\"45-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"45-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete Expression  Athlete Expression The Athlete Expression guidelines outline the opportunities you have to express your views while respecting others. • Sport at the Olympic Games is neutral and must be separate from political, religious or any other type of interference. • The focus on the field of play during competitions and official ceremonies must be on celebrating athletes' performances. • The Olympic Village must provide respectful conditions for all athletes to live together.  Read the guidelines in full  NEED TO KNOW  45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 46-title\" style=\"top:422px;left:21px;\" src=\"/milanocortina2026/en/static/_content/46-title-1.png\"/>\n      <img class=\"abs halfScale 46-sub\" style=\"top:486px;left:22px;\" src=\"/milanocortina2026/en/static/_content/46-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/articles/rule-40/rule-40-resources-for-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 46-btn\" style=\"top:689px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/46-btn-1.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"46-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Commercial opportunities  commercial opportunities How to engage in and benefit from commercial activities during the Games. • As athletes, you are able to generate income through personal sponsorships with well-planned advertising during Milano Cortina 2026, as long as you follow the r equirements of the Rule 40 framework. • By doing this, you help the Olympic Movement maintain its solidarity funding model, ensuring athletes from around the world are able to participate in the Games. • Read the Key Principles, Illustrative Guidance and FAQs now to understand your rights and responsibilities.  Find out more  NEED TO KNOW  46"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 47-title\" style=\"top:135px;left:21px;\" src=\"/milanocortina2026/en/static/_content/47-title-1.png\"/>\n      <img class=\"abs halfScale 47-title\" style=\"top:187px;left:21px;\" src=\"/milanocortina2026/en/static/_content/47-title-2.png\"/>\n      <img class=\"abs halfScale 47-title\" style=\"top:239px;left:21px;\" src=\"/milanocortina2026/en/static/_content/47-title-3.png\"/>\n      <img class=\"abs halfScale 47-sub\" style=\"top:306px;left:22px;\" src=\"/milanocortina2026/en/static/_content/47-sub-1.png\"/>\n\n      <a href=\"https://www.olympics.com/athlete365/topics/believeinsport?nxtPpath=believeinsport \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 47-btn\" style=\"top:503px;left:-17px;\" src=\"/milanocortina2026/en/static/_content/47-btn-1.png\"/>\n      </a>\n      <a href=\"https://ioc.integrityline.org/ \" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 47-btn\" style=\"top:635px;left:321px;\" src=\"/milanocortina2026/en/static/_content/47-btn-2.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"47-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Prevention of competition manipulation  Prevention of Competition Manipulation What’s the point of sport if the result is fixed in advance? Make the right decision and join the fight against competition manipulation. Competition manipulation happens when athletes intentionally underperform or lose on purpose. It’s also when officials intentionally make wrong decisions affecting the competition. This may be for a financial, sporting or other advantage.  47  There are four key rules to follow as athletes: We will not fix the competition and always do our best.  We will not bet on our own sport or any event at the Olympic Games.  We will not share information about health issues or sport tactics.  We will speak up if we witness or suspect competition manipulation.  Learn more Suspicious activity should be reported through the IOC Integrity Hotline. All matters are dealt with professionally, with full confidentiality and anonymity.  IOC Integrity Hotline  NEED TO KNOW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 48-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/48-title-1.png\"/>\n      <img class=\"abs halfScale 48-sub\" style=\"top:149px;left:21px;\" src=\"/milanocortina2026/en/static/_content/48-sub-1.png\"/>\n\n      <a href=\"https://img.olympics.com/images/image/private/w_auto/primary/mztq85yvowvi4ciehdw7\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 48-btn\" style=\"top:557px;left:-46px;\" src=\"/milanocortina2026/en/static/_content/48-btn-1.png\"/>\n      </a>\n      <a href=\"https://www.olympics.com/athlete365/news/antidoping/key-anti-doping-resources-available-for-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 48-btn\" style=\"top:618px;left:-14px;\" src=\"/milanocortina2026/en/static/_content/48-btn-2.png\"/>\n      </a>\n\n    ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"48-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Anti-doping  Anti-doping rules All athletes competing at the Olympic Games – and their entourage members – must comply with the IOC's anti-doping policies. As athletes and entourage members, you are solely responsible for ensuring that you comply with the anti-doping rules at the Olympic Games. To protect yourself and your place at the Games, it is essential that you understand the rules that are in place. Ahead of Milano Cortina 2026, the IOC has confirmed the anti-doping rules and system for the upcoming Olympic Winter Games.  Full anti-doping rules  Resources  NEED TO KNOW  48"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n        <img class=\"abs halfScale 49-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/49-title-1.png\"/>\n        <img class=\"abs halfScale 49-sub\" style=\"top:147px;left:21px;\" src=\"/milanocortina2026/en/static/_content/49-sub-1.png\"/>\n\n        <img class=\"abs halfScaleC 49-sub-2\" style=\"top:243px;left:-32px;\" src=\"/milanocortina2026/en/static/_content/49-sub-2.png\"/>\n        <img class=\"abs halfScaleC 49-sub-2\" style=\"top:243px;left:128px;\" src=\"/milanocortina2026/en/static/_content/49-sub-3.png\"/>\n        <img class=\"abs halfScaleC 49-sub-2\" style=\"top:243px;left:372px;\" src=\"/milanocortina2026/en/static/_content/49-sub-4.png\"/>\n\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:318px;left:-6px;\" src=\"/milanocortina2026/en/static/_content/49-icon-1.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:349px;left:49px;\" src=\"/milanocortina2026/en/static/_content/49-text-1.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:360px;left:-25px;\" src=\"/milanocortina2026/en/static/_content/49-line-1.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:449px;left:109px;\" src=\"/milanocortina2026/en/static/_content/49-icon-2.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:480px;left:27px;\" src=\"/milanocortina2026/en/static/_content/49-text-2.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:508px;left:-20px;\" src=\"/milanocortina2026/en/static/_content/49-line-2.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:561px;left:-6px;\" src=\"/milanocortina2026/en/static/_content/49-icon-3.png\"/>\n        <img class=\"abs halfScaleC 49-col-1\" style=\"top:579px;left:44px;\" src=\"/milanocortina2026/en/static/_content/49-text-3.png\"/>\n\n        <img class=\"abs halfScale 49-box\" style=\"top:685px;left:-260px;\" src=\"/milanocortina2026/en/static/_content/49-box.png\"/>\n        <img class=\"abs halfScaleC 49-col-1-pull-out-box\" style=\"top:673px;left:2px;\" src=\"/milanocortina2026/en/static/_content/49-icon-4.png\"/>\n        <img class=\"abs halfScaleC 49-col-1-pull-out-box\" style=\"top:720px;left:-32px;\" src=\"/milanocortina2026/en/static/_content/49-text-4.png\"/>\n        <a href=\"https://stillmed.olympics.com/media/Documents/Beyond-the-Games/Sustainability/Essentials/How-to-be-a-sustainable-champion-guide.pdf\" target=\"_blank\">\n          <img class=\"abs halfScaleC 49-col-1-pull-out-box\" style=\"top:769px;left:-23px;\" src=\"/milanocortina2026/en/static/_content/49-btn-1.png\"/>\n        </a>\n\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:278px;left:141px;\" src=\"/milanocortina2026/en/static/_content/49-piechart.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:384px;left:167px;\" src=\"/milanocortina2026/en/static/_content/49-text-5.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:292px;left:315px;\" src=\"/milanocortina2026/en/static/_content/49-line-3.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:439px;left:277px;\" src=\"/milanocortina2026/en/static/_content/49-text-6.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:384px;left:202px;\" src=\"/milanocortina2026/en/static/_content/49-icon-5.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:422px;left:203px;\" src=\"/milanocortina2026/en/static/_content/49-line-4.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:491px;left:160px;\" src=\"/milanocortina2026/en/static/_content/49-text-7.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:458px;left:311px;\" src=\"/milanocortina2026/en/static/_content/49-icon-6.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:487px;left:388px;\" src=\"/milanocortina2026/en/static/_content/49-line-5.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:551px;left:274px;\" src=\"/milanocortina2026/en/static/_content/49-text-8.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:518px;left:225px;\" src=\"/milanocortina2026/en/static/_content/49-icon-7.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:544px;left:229px;\" src=\"/milanocortina2026/en/static/_content/49-line-6.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:613px;left:200px;\" src=\"/milanocortina2026/en/static/_content/49-text-9.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:653px;left:182px;\" src=\"/milanocortina2026/en/static/_content/49-text-10.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:593px;left:297px;\" src=\"/milanocortina2026/en/static/_content/49-icon-8.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:631px;left:382px;\" src=\"/milanocortina2026/en/static/_content/49-line-7.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:691px;left:286px;\" src=\"/milanocortina2026/en/static/_content/49-text-11.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:673px;left:234px;\" src=\"/milanocortina2026/en/static/_content/49-icon-9.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:698px;left:198px;\" src=\"/milanocortina2026/en/static/_content/49-line-8.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:772px;left:178px;\" src=\"/milanocortina2026/en/static/_content/49-text-12.png\"/>\n        <img class=\"abs halfScaleC 49-col-2\" style=\"top:742px;left:304px;\" src=\"/milanocortina2026/en/static/_content/49-icon-10.png\"/>\n        <h1 id=\"49-no\" class=\"abs olympicHeadlineReg 49-no\" style=\"top:341px;left:229px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85, \"append\": \"%\"}' ></h1>\n        <h1 id=\"49-no\" class=\"abs olympicHeadlineReg 49-no\" style=\"top:412px;left:336px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"append\": \"%\"}' ></h1>\n        <h1 id=\"49-no\" class=\"abs olympicHeadlineReg 49-no\" style=\"top:624px;left:217px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20000, \"comma\": true}' ></h1>\n\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:349px;left:451px;\" src=\"/milanocortina2026/en/static/_content/49-text-13.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:318px;left:398px;\" src=\"/milanocortina2026/en/static/_content/49-icon-11.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:380px;left:386px;\" src=\"/milanocortina2026/en/static/_content/49-line-9.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:439px;left:399px;\" src=\"/milanocortina2026/en/static/_content/49-text-14.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:420px;left:521px;\" src=\"/milanocortina2026/en/static/_content/49-icon-12.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:488px;left:395px;\" src=\"/milanocortina2026/en/static/_content/49-line-10.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:531px;left:441px;\" src=\"/milanocortina2026/en/static/_content/49-text-15.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:514px;left:403px;\" src=\"/milanocortina2026/en/static/_content/49-icon-13.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:578px;left:392px;\" src=\"/milanocortina2026/en/static/_content/49-line-11.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:628px;left:438px;\" src=\"/milanocortina2026/en/static/_content/49-text-16.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:609px;left:522px;\" src=\"/milanocortina2026/en/static/_content/49-icon-14.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:677px;left:392px;\" src=\"/milanocortina2026/en/static/_content/49-line-12.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:723px;left:445px;\" src=\"/milanocortina2026/en/static/_content/49-text-17.png\"/>\n        <img class=\"abs halfScaleC 49-col-3\" style=\"top:705px;left:404px;\" src=\"/milanocortina2026/en/static/_content/49-icon-15.png\"/>\n    ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.staggerFromTo(cOf(\"49-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"49-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n          .staggerFromTo(cOf(\"49-sub-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5)\n          .staggerFromTo(cOf(\"49-col-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n          .staggerFromTo(cOf(\"49-col-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7)\n          .staggerFromTo(cOf(\"49-col-3\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)\n          .fromTo(cOf(\"49-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[0])}}, 1.8)\n          .fromTo(cOf(\"49-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[1])}}, 2)\n          .fromTo(cOf(\"49-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[2])}}, 3)\n          .fromTo(cOf(\"49-box\"), 0.8, {opacity:0, x: -120}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2.3)\n          .staggerFromTo(cOf(\"49-col-1-pull-out-box\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.5)\n          \n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"49-no\");\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Sustainability  Contents  49  Sustainability at the Games Milano Cortina 2026 has set out a number of objectives to make the Games more sustainable. As athletes, you have a key role to play.  Sustainability objectives:  Minimise the carbon footprint  How will Milano Cortina 2026 achieve this?  85%  How can athletes contribute?  Avoid single-use plastic items  existing or temporary venues  100%  renewable energy at venues Protect natural ecosystems  Transportation plan favouring trains and buses  Low carbon menus and local products Reduce waste and promote circular economy  20,000  Drink tap water instead of bottled water Biodiversity conservation and restoration plans  Learn how you can be a sustainable champion with our guide  NEED TO KNOW  Opt for low carbon and more sustainable food options  Reuse of  equipment items from Paris 2024  Find out more  Follow waste-sorting instructions to maximise recycling  More energy-efficient snow-making system  Keep it simple and refuse any unnecessary goods"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"abs pointer\" onclick=\"Publish.goToPage(2);\" style=\"top:9px; left:16px; width:51px; height:16px;\"></div>\n      \n      <img class=\"abs halfScale 50-title\" style=\"top:85px;left:21px;\" src=\"/milanocortina2026/en/static/_content/50-title-1.png\"/>\n      <img class=\"abs halfScale 50-sub\" style=\"top:147px;left:21px;\" src=\"/milanocortina2026/en/static/_content/50-sub-1.png\"/>\n\n      <img class=\"abs halfScaleC 50-textbubble\" style=\"top:76px;left:-108px;\" src=\"/milanocortina2026/en/static/_content/50-textbubble.png\"/>\n\n      <img class=\"abs halfScaleC 50-arrow\" style=\"top:328px;left:101px;\" src=\"/milanocortina2026/en/static/_content/50-arrow-1.png\"/>\n      <img class=\"abs halfScaleC 50-arrow\" style=\"top:396px;left:82px;\" src=\"/milanocortina2026/en/static/_content/50-arrow-2.png\"/>\n      <img class=\"abs halfScaleC 50-arrow\" style=\"top:253px;left:128px;\" src=\"/milanocortina2026/en/static/_content/50-arrow-3.png\"/>\n      <img class=\"abs halfScaleC 50-arrow\" style=\"top:289px;left:111px;\" src=\"/milanocortina2026/en/static/_content/50-arrow-4.png\"/>\n      <img class=\"abs halfScaleC 50-arrow\" style=\"top:150px;left:129px;\" src=\"/milanocortina2026/en/static/_content/50-arrow-5.png\"/>\n\n      <img class=\"abs halfScaleC 50-yesno\" style=\"top:496px;left:75px;\" src=\"/milanocortina2026/en/static/_content/50-yes.png\"/>\n      <img class=\"abs halfScaleC 50-yesno\" style=\"top:450px;left:143px;\" src=\"/milanocortina2026/en/static/_content/50-yes.png\"/>\n      <img class=\"abs halfScaleC 50-yesno\" style=\"top:492px;left:341px;\" src=\"/milanocortina2026/en/static/_content/50-yes.png\"/>\n      <img class=\"abs halfScaleC 50-yesno\" style=\"top:316px;left:377px;\" src=\"/milanocortina2026/en/static/_content/50-yes.png\"/>\n      <img class=\"abs halfScaleC 50-yesno\" style=\"top:184px;left:343px;\" src=\"/milanocortina2026/en/static/_content/50-no.png\"/>\n\n      <img class=\"abs halfScaleC 50-text\" style=\"top:607px;left:-80px;\" src=\"/milanocortina2026/en/static/_content/50-text-1.png\"/>\n      <img class=\"abs halfScaleC 50-text\" style=\"top:436px;left:102px;\" src=\"/milanocortina2026/en/static/_content/50-text-2.png\"/>\n      <img class=\"abs halfScaleC 50-text\" style=\"top:615px;left:187px;\" src=\"/milanocortina2026/en/static/_content/50-text-3.png\"/>\n      <img class=\"abs halfScaleC 50-text\" style=\"top:457px;left:350px;\" src=\"/milanocortina2026/en/static/_content/50-text-4.png\"/>\n      <img class=\"abs halfScaleC 50-text\" style=\"top:212px;left:345px;\" src=\"/milanocortina2026/en/static/_content/50-text-5.png\"/>\n\n      <img class=\"abs halfScaleC 50-icon\" style=\"top:609px;left:64px;\" src=\"/milanocortina2026/en/static/_content/50-icon-1.png\"/>\n      <img class=\"abs halfScaleC 50-icon\" style=\"top:442px;left:216px;\" src=\"/milanocortina2026/en/static/_content/50-icon-2.png\"/>\n      <img class=\"abs halfScaleC 50-icon\" style=\"top:608px;left:330px;\" src=\"/milanocortina2026/en/static/_content/50-icon-3.png\"/>\n      <img class=\"abs halfScaleC 50-icon\" style=\"top:440px;left:455px;\" src=\"/milanocortina2026/en/static/_content/50-icon-4.png\"/>\n      <img class=\"abs halfScaleC 50-icon\" style=\"top:170px;left:450px;\" src=\"/milanocortina2026/en/static/_content/50-icon-5.png\"/>\n\n      \n      <img class=\"abs halfScale 50-textbox\" style=\"top:639px;left:482px;\" src=\"/milanocortina2026/en/static/_content/50-textbox.png\"/>\n      <img class=\"abs halfScale 50-bottom-bar-1\" style=\"top:832px;left:-35px;\" src=\"/milanocortina2026/en/static/_content/50-bottom-bar-1.png\" />\n      \n\n    ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.staggerFromTo(cOf(\"50-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"50-sub\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n          .fromTo(cOf(\"50-textbubble\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n          .staggerFromTo(cOf(\"50-arrow\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5)\n          .staggerFromTo(cOf(\"50-yesno\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n          .staggerFromTo(cOf(\"50-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7)\n          .staggerFromTo(cOf(\"50-text\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)\n          .fromTo(cOf(\"50-textbox\"), 0.8, {opacity:0, y: 200}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2.2)\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Get Ready Pack: Milano Cortina 2026 | Departures  Contents  50  Heading home What to expect when departing the Games.  NO Departure services will be organised by your NOC for return to your port of exit.  ARE YOU ATTENDING THE CLOSING CEREMONY?  yes  yes yes  Option 1 Leave straight to the airport: Shuttle buses will take you to Verona Porta Nuova train station, then you will get the train to Milano Malpensa or Venezia Marco Polo Airport. If you are leaving the next day, dedicated waiting areas will be in place at the airport.  NEED TO KNOW  yes  Option 2  Option 4  Leave via the Milan Village:  drive yourself:  If you have a bed in the Milan Village, you can return for the night. If you don’t have a bed but would like to wait for your onward travel in Milan, there will be dedicated waiting areas in place in the Village.  Park and ride services will be provided for athletes who wish to drive to the Closing Ceremony.  Option 3 Return to your Village: If you want to return to your Village, dedicated buses will be in place. Departure services will then be organised by your NOC for return to your port of exit.  Please speak to your NOC, e.g. your Chef de Mission, for more information."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n\n        <a href=\"https://www.olympics.com/athlete365/articles/milano-cortina2026/don-t-miss-these-services-in-your-village-at-milano-cortina-2026\" target=\"_blank\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse 51-btn\" style=\"top:801px;left:78px;\" src=\"/milanocortina2026/en/static/_content/51-btn-1.png\"/>\n      </a>\n      \n      ",

    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Thank you to our Worldwide Olympic Partners  ALL WORLDWIDE OLYMPIC PARTNER SERVICES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLink\" style=\"top:202px;left:236px;width:32px;height:40px\">\n        <a href=\"https://www.facebook.com/Athlete365/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:202px;left:272px;width:32px;height:40px\">\n        <a href=\"https://www.linkedin.com/showcase/athlete365/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:202px;left:310px;width:32px;height:40px\">\n        <a href=\"https://x.com/Athlete365\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:202px;left:344px;width:32px;height:40px\">\n        <a href=\"https://www.instagram.com/athlete365/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:244px;left:230px;width:161px;height:19px\">\n        <a href=\"https://www.olympics.com/athlete365\" target=\"_blank\"></a>\n      </div>",

    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "FOLLOW US olympics.com/athlete365"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-7E06PYSWCS" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NXlJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAiT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "biBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bp21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ckHF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "opfQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u/WO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uL/m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xda7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fbfe6e71a5cb7f35a355.js